import React from 'react';
import { 
  Dialog, DialogTitle, DialogContent, TextField, Button, DialogActions, Stack,
  FormControl, InputLabel, Select, MenuItem
} from '@mui/material';

const AddSiteDialog = ({ isOpen, onClose, formData, onChange, onSubmit, error }) => {
  return (
    <Dialog 
      open={isOpen} 
      onClose={onClose}
      PaperProps={{
        sx: { 
          borderRadius: "12px", 
          padding: "20px",
          boxShadow: "0px 8px 24px rgba(0,0,0,0.15)"
        }
      }}
    >
      <DialogTitle sx={{ fontWeight: "600", color: "#374151" }}>
        Add New Site
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ marginTop: "10px" }}>
          <TextField
            fullWidth
            label="Project No."
            name="id"
            value={formData.id}
            onChange={onChange}
            variant="outlined"
          />
          <TextField fullWidth label="Project Name" name="name" value={formData.name} onChange={onChange} variant="outlined" />
          <TextField fullWidth label="Client" name="client" value={formData.client} onChange={onChange} variant="outlined" />
          <TextField fullWidth label="Location" name="location" value={formData.location} onChange={onChange} variant="outlined" />
          <FormControl fullWidth variant="outlined">
            <InputLabel id="site-status-label">Status</InputLabel>
            <Select
              labelId="site-status-label"
              label="Status"
              name="status"
              value={formData.status || 'Ongoing'}
              onChange={onChange}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Ongoing">Ongoing</MenuItem>
            </Select>
          </FormControl>
          <TextField fullWidth label="Plant Type" name="type" value={formData.type} onChange={onChange} variant="outlined" />
          <TextField 
            fullWidth 
            label="Date of Installation" 
            name="date" 
            type="date" 
            value={formData.date} 
            onChange={onChange} 
            variant="outlined"
            InputLabelProps={{ shrink: true }}
          />
          <Stack direction="row" spacing={2}>
            <TextField fullWidth label="X Coordinate" name="xCoordinate" value={formData.xCoordinate} onChange={onChange} variant="outlined" />
            <TextField fullWidth label="Y Coordinate" name="yCoordinate" value={formData.yCoordinate} onChange={onChange} variant="outlined" />
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ padding: "16px" }}>
        <Button onClick={onClose} color="secondary" sx={{ textTransform: "none" }}>
          Cancel
        </Button>
        <Button 
          onClick={onSubmit} 
          variant="contained" 
          color="primary" 
          sx={{ textTransform: "none", boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" }}
        >
          Add Site
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSiteDialog;
